import styled from 'styled-components';

export const Icon = styled.svg`
  transition:
    opacity 0.1s ease,
    fill 0.1s ease,
    color 0.1s ease;
`;
